import { useState } from "react"

const useMenu = () => {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    return {
        anchorEl,
        open,
        handleOpen,
        handleClose,
    }

}

export default useMenu
